import { render } from "./MoreBannerCard.vue?vue&type=template&id=3cd36b28"
import script from "./MoreBannerCard.vue?vue&type=script&lang=js"
export * from "./MoreBannerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__